import { z } from "zod"
import {
  CANONICAL_RANKING_TOP_N,
  DailyStackedActivityDataSchema,
} from "../../insights/response_data"
import { BackofficeFlagsKindEnum } from "./dtos"

export const BACKOFFICE_FLAGS_RANKING_TOP_N = CANONICAL_RANKING_TOP_N
export const BACKOFFICE_FLAGS_TIMELINE_DAYS = 12

export const GetBackofficeFlagsActivityResponseDataSchema = z.object({
  namespaces: z.array(z.string()),
  dailyCount: DailyStackedActivityDataSchema,
})

export const BackofficeFlagsTimelineRankingResponseDataSchema = z.object({
  key: z.string(),
  kind: z.enum(BackofficeFlagsKindEnum),
  count: z.number(),
  rank: z.number(),
  share: z.number().nullable(),
})

export const BackofficeFlagsTimelineResponseDataSchema = z.object({
  overallRanking: z.array(BackofficeFlagsTimelineRankingResponseDataSchema),
  timeline: z.array(
    z.object({
      date: z.date().transform((value) => value.toISOString()),
      periodTotalFlags: z.number(),
      rankings: z.array(BackofficeFlagsTimelineRankingResponseDataSchema),
    }),
  ),
})

export const BackofficeFlagsCampaignResponseDataSchema = z.object({
  id: z.bigint().transform(String),
  name: z.string().nullable(),
})

export const BackofficeFlagsCampaignsResponseDataSchema = z.array(
  BackofficeFlagsCampaignResponseDataSchema,
)

export const BackofficeFlagsTreemapKeyResponseDataSchema = z.object({
  key: z.string(),
  kind: z.enum(BackofficeFlagsKindEnum),
  count: z.number(),
})

export const BackofficeFlagsTreemapNamespaceResponseDataSchema = z.object({
  namespace: z.string(),
  count: z.number(),
  keys: z.array(BackofficeFlagsTreemapKeyResponseDataSchema),
})

export const BackofficeFlagsTreemapKeysResponseDataSchema = z.object({
  groupBy: z.literal("key"),
  namespaces: z.array(BackofficeFlagsTreemapNamespaceResponseDataSchema),
})

export const BackofficeFlagsTreemapCompanyResponseDataSchema = z.object({
  id: z.bigint().transform(String),
  name: z.string().nullable(),
  count: z.number(),
  rate: z.number(),
})

export const BackofficeFlagsTreemapCompaniesResponseDataSchema = z.object({
  groupBy: z.literal("company"),
  companies: z.array(BackofficeFlagsTreemapCompanyResponseDataSchema),
})

export const GetBackofficeFlagsTreemapResponseDataSchema = z.discriminatedUnion("groupBy", [
  BackofficeFlagsTreemapKeysResponseDataSchema,
  BackofficeFlagsTreemapCompaniesResponseDataSchema,
])

export const BackofficeFlagsConversationKeyResponseDataSchema = z.object({
  key: z.string(),
  kind: z.enum(BackofficeFlagsKindEnum),
  count: z.number(),
})

export const BackofficeFlagsConversationResponseDataSchema = z.object({
  conversationId: z.bigint().transform(String),
  organizationId: z.bigint().transform(String),
  createdAt: z.date().transform((d) => d.toISOString()),
  lastFlaggedAt: z.date().transform((d) => d.toISOString()),
  issueCount: z.number(),
  frictionCount: z.number(),
  keys: z.array(BackofficeFlagsConversationKeyResponseDataSchema),
  company: z.object({
    id: z.bigint().transform(String),
    name: z.string().nullable(),
    logo: z.string().nullable(),
  }),
  campaign: z
    .object({
      id: z.bigint().transform(String),
      name: z.string().nullable(),
    })
    .nullable(),
  channel: z.string(),
  assistantMessages: z.number(),
  customer: z.object({
    id: z.bigint().transform(String),
    name: z.string().nullable(),
  }),
})

export const BackofficeFlagsConversationsResponseDataSchema = z.array(
  BackofficeFlagsConversationResponseDataSchema,
)
